import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaModuloNome = (): TabelaColuna => ({
  Chave: 'nomeModulo',
  RenderizarCabecalho: () => <div style={{ width: 150 }}>Nome Módulo</div>
})
